'use client'

import useEnquiry from '@hooks/useEnquiry'
import { enquiryDataLayer } from '@plugin/google/gtm/modules/property'
import { statsEnquiryClick } from '@plugin/statistics'
import classNames from 'classnames'
import { isFunction } from 'lodash-es'
import { useSearchParams } from 'next/navigation'
import { useCallback, useMemo } from 'react'
import { useMount, useSessionStorage } from 'react-use'

const stats = statsEnquiryClick()
export default function AgentEnquiryButton({
  data,
  house,
  className,
  onClick,
  sendAllAgent = false
}) {

  const searchParams = useSearchParams()
  const viewEmailEnquiry = useMemo(() => searchParams.get('viewEmailEnquiry'), [searchParams])
  const [viewedEnquiryId, setViewedEnquiryId] = useSessionStorage('viewedEnquiryId')
  const { showHouseEnquiry } = useEnquiry()
  const clickHandle = useCallback(event => {
    isFunction(onClick) && onClick(event)
    enquiryDataLayer.click()
    showHouseEnquiry({ house, agent: data, sendAllAgent, signupSource: 'agent_enquiry' })(event)
    stats(house.houseId)
  }, [showHouseEnquiry, data, house, onClick, sendAllAgent])

  useMount(() => {
    if (viewEmailEnquiry && data.id === parseInt(viewEmailEnquiry) && viewedEnquiryId !== data.id) {
      clickHandle()
      setViewedEnquiryId(data.id)
    }
  })

  return (
    <button
      className={classNames('button-orange w-full', className)}
      onClick={clickHandle}
      data-noprogress
    >Enquire</button>
  )
}
